/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Code_HintInputs */

const en_admin_discounts_code_hint = /** @type {(inputs: Admin_Discounts_Code_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code that members will use to redeem the discount`)
};

const de_admin_discounts_code_hint = /** @type {(inputs: Admin_Discounts_Code_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Code, den Mitglieder zur Einlösung des Rabatts verwenden`)
};

const es_admin_discounts_code_hint = /** @type {(inputs: Admin_Discounts_Code_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El código que los miembros usarán para canjear el descuento`)
};

const fr_admin_discounts_code_hint = /** @type {(inputs: Admin_Discounts_Code_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le code que les membres utiliseront pour obtenir la réduction`)
};

/** @type {(inputs: Admin_Discounts_Code_HintInputs) => LocalizedString} */
const it_admin_discounts_code_hint = en_admin_discounts_code_hint;

/** @type {(inputs: Admin_Discounts_Code_HintInputs) => LocalizedString} */
const pt_br2_admin_discounts_code_hint = en_admin_discounts_code_hint;

/** @type {(inputs: Admin_Discounts_Code_HintInputs) => LocalizedString} */
const pl_admin_discounts_code_hint = en_admin_discounts_code_hint;

/** @type {(inputs: Admin_Discounts_Code_HintInputs) => LocalizedString} */
const hu_admin_discounts_code_hint = en_admin_discounts_code_hint;

/** @type {(inputs: Admin_Discounts_Code_HintInputs) => LocalizedString} */
const ro_admin_discounts_code_hint = en_admin_discounts_code_hint;

/**
* | output |
* | --- |
* | "The code that members will use to redeem the discount" |
*
* @param {Admin_Discounts_Code_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_code_hint = /** @type {((inputs?: Admin_Discounts_Code_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Code_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_code_hint(inputs)
	if (locale === "de") return de_admin_discounts_code_hint(inputs)
	if (locale === "es") return es_admin_discounts_code_hint(inputs)
	if (locale === "fr") return fr_admin_discounts_code_hint(inputs)
	if (locale === "it") return it_admin_discounts_code_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_code_hint(inputs)
	if (locale === "pl") return pl_admin_discounts_code_hint(inputs)
	if (locale === "hu") return hu_admin_discounts_code_hint(inputs)
	return ro_admin_discounts_code_hint(inputs)
});
export { admin_discounts_code_hint as "admin.discounts.code_hint" }